import type { CreditCardTypes } from "@/api/credit-cards/credit-cards";

const CARD_TYPE_ABBREVIATIONS: Record<string, CreditCardTypes> = {
	V: "VISA",
	M: "MASTERCARD",
	MC: "MASTERCARD",
	A: "AMEX",
	AX: "AMEX",
	X: "AMEX",
	D: "DISCOVER",
	R: "DISCOVER",
};

const FULL_CARD_TYPES = new Set<CreditCardTypes>([
	"VISA",
	"MASTERCARD",
	"DISCOVER",
	"AMEX",
	"OTHER",
]);

export function mapTransactionCardType(
	raw: string | null | undefined,
): CreditCardTypes {
	if (!raw) return "OTHER";

	const normalized = raw.trim().toUpperCase();

	if (normalized in CARD_TYPE_ABBREVIATIONS) {
		return CARD_TYPE_ABBREVIATIONS[normalized];
	}

	if (FULL_CARD_TYPES.has(normalized as CreditCardTypes)) {
		return normalized as CreditCardTypes;
	}

	return "OTHER";
}
